import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=0dcbc369&"
var script = {}
import style0 from "../assets/css/home.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports